(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-g1]";
  const MOBILE_MQ = "(max-width: 720px)";

  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function pauseVideo(video) {
    if (!video) return;
    video.pause();
  }

  function getVideos(section) {
    return Array.from(section.querySelectorAll("video.kit-set-g1__player"));
  }

  function bindObserver(section) {
    if (section.__kitSetG1Observer) {
      section.__kitSetG1Observer.disconnect();
      section.__kitSetG1Observer = null;
    }

    var videos = getVideos(section);
    if (videos.length === 0 || typeof IntersectionObserver === "undefined") {
      videos.forEach(playVideo);
      return;
    }

    section.__kitSetG1Observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            playVideo(video);
          } else {
            pauseVideo(video);
          }
        });
      },
      { root: null, threshold: 0.35 }
    );

    videos.forEach(function (video) {
      section.__kitSetG1Observer.observe(video);
    });
  }

  function unbindDrag(section) {
    if (typeof section.__kitSetG1DragCleanup === "function") {
      section.__kitSetG1DragCleanup();
      section.__kitSetG1DragCleanup = null;
    }
  }

  /** 移动端 pointer 拖拽：DevTools 模拟器鼠标拖动也能横滑 */
  function bindDrag(section) {
    var wrap = section.querySelector(".kit-set-g1__track-wrap");
    if (!wrap) return;

    unbindDrag(section);

    if (!window.matchMedia(MOBILE_MQ).matches) return;

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    function onPointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) return;
      dragging = true;
      moved = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = wrap.scrollLeft;
      wrap.classList.add("is-dragging");
      try {
        wrap.setPointerCapture(event.pointerId);
      } catch (err) {}
    }

    function onPointerMove(event) {
      if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
      var dx = event.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      wrap.scrollLeft = startScroll - dx;
      if (moved) event.preventDefault();
    }

    function onPointerUp(event) {
      if (!dragging || (pointerId !== null && event.pointerId !== pointerId)) return;
      dragging = false;
      pointerId = null;
      wrap.classList.remove("is-dragging");
      try {
        wrap.releasePointerCapture(event.pointerId);
      } catch (err) {}
    }

    function onClickCapture(event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }

    wrap.addEventListener("pointerdown", onPointerDown);
    wrap.addEventListener("pointermove", onPointerMove, { passive: false });
    wrap.addEventListener("pointerup", onPointerUp);
    wrap.addEventListener("pointercancel", onPointerUp);
    wrap.addEventListener("click", onClickCapture, true);

    section.__kitSetG1DragCleanup = function () {
      wrap.removeEventListener("pointerdown", onPointerDown);
      wrap.removeEventListener("pointermove", onPointerMove);
      wrap.removeEventListener("pointerup", onPointerUp);
      wrap.removeEventListener("pointercancel", onPointerUp);
      wrap.removeEventListener("click", onClickCapture, true);
      wrap.classList.remove("is-dragging");
    };
  }

  function applyMode(section) {
    bindObserver(section);
    bindDrag(section);
  }

  function initSection(section) {
    if (!section) return;
    applyMode(section);

    if (!section.__kitSetG1ResizeBound) {
      section.__kitSetG1ResizeBound = true;
      var frame = 0;
      window.addEventListener("resize", function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          applyMode(section);
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR));
  });
})();
